import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const ArticleHeaderCCD: IClientComponentDefinition = {
  name: 'WArticleHeader',
  load: () => import(/* webpackChunkName: 'WArticleHeader' */ './index'),
}
